import currency from './currency';
import store from '../store';
import moment from "moment/moment";

const formatCurrency = (num, project) => {
  if (!project) {
    return '';
  }
  currency.locale(store.getters.currencyCodeById(project.currencyId));
  return currency(num).format('$0a.[0]');
};

const getFyEnd = () => {
  const thisYear = new Date().getFullYear();
  const fy_month = store.getters.app_user.organization.fy_month;

  let current_fy_end = moment(fy_month + ' ' + thisYear, 'MMMM YYYY').subtract(
    1,
    'd'
  );
  if (moment().isAfter(current_fy_end)) {
    current_fy_end = current_fy_end.add(1, 'y');
  }
  return current_fy_end
}

const benefitsPopoverContent = (project, forecastedOnly = false, fyOnly = false) => {
  if (!project || !project.projectBenefits || !(forecastedOnly ? project.forecasted_benefits : project.total_benefits)) {
    return '';
  }

  let currentFyEnd
  if(fyOnly) currentFyEnd = getFyEnd()

  const savingsTypes =
    store.getters.org && store.getters.org.savingsTypes
      ? store.getters.org.savingsTypes
      : [];
  let data = [];

  savingsTypes.forEach(savingsType => {
    let total = project.projectBenefits
      .filter(benefit => {
        return (benefit.savingsTypeId === savingsType.id) &&
          (!currentFyEnd ? true : currentFyEnd.isSame(moment(benefit.yearEnding, 'YYYY'), 'y'))
      })
      .reduce((acc, curr) => {
        return acc + (+(forecastedOnly ? curr.forecastedAmount : curr.amount) || 0)
      }, 0);

    data.push({ name: savingsType.name, amount: total });
  });

  data.sort(function(a, b) {
    var textA = a.name.toLowerCase();
    var textB = b.name.toLowerCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });

  let html = ``;

  html += `<div class="large">`;

  data.forEach(benefitType => {
    html += `<h6><span>${benefitType.name}:</span> ${formatCurrency(
      benefitType.amount,
      project
    )}</h6>`;
  });

  html += `</div>`;

  return html;
};

export default benefitsPopoverContent;
